import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { CabinetViewAdminComponent } from './cabinet-view-admin/cabinet-view-admin.component';
import { CabinetDetailComponent } from './cabinet-detail/cabinet-detail.component';
import { SlotViewAdminComponent } from './cabinet-detail/slot-view-admin/slot-view-admin.component';
import { CabinetViewClientComponent } from './cabinet-view-client/cabinet-view-client.component';
import { SlotProductViewAdminComponent } from './cabinet-detail/slot-view-admin/slot-product-view-admin/slot-product-view-admin.component';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";

@NgModule({
  declarations: [
    CabinetViewAdminComponent,
    CabinetViewClientComponent,
    CabinetDetailComponent,
    SlotViewAdminComponent,
    SlotProductViewAdminComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GridModule,
    IndicatorsModule,
    UploadsModule,
    DateInputsModule,
    SharedModule,
  ],
  exports: [
    CabinetViewAdminComponent,
    SlotViewAdminComponent
  ]
})
export class CabinetModule { }
